import axios from 'axios';
import {
  loanBackendUrl,
  mobileOtpRequestHeaders,
  saveEnquiryUrl,
  saveLendingPageUrl,
  sendOtpUrl,
  taskApiDirectUrl,
  taskApiPostUrl,
  verifyOtpUrl,
} from './taskApi';

export const GW = {
  GET_STATE: 'a1',
  GET_CITY: 'a2',
  GET_PINCODE: 'a3',
  OTP_SEND: 'm1',
  OTP_VERIFY: 'm2',
  VERIFY_PAN: 'p1',
  PAN_BLACKLIST: 'p2',
  PAN_CUSTOMER: 'p3',
  AADHAAR_SEND: 'k1',
  AADHAAR_VERIFY: 'k2',
  SAVE_ENQUIRY: 'e1',
  SAVE_LEAD: 'l1',
};

/** Direct mrrupya.in APIs — no gateway proxy */
export const apiGateway = async (action, payload = {}, options = {}) => {
  const timeout = options.timeout || 30000;
  const jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

  switch (action) {
    case GW.GET_STATE:
      return axios.get(taskApiPostUrl('getState'), { timeout });
    case GW.GET_CITY:
      return axios.post(taskApiPostUrl('getCity'), payload, { headers: jsonHeaders, timeout });
    case GW.GET_PINCODE:
      return axios.post(taskApiPostUrl('getPincodeByCityId'), payload, {
        headers: jsonHeaders,
        timeout,
      });
    case GW.OTP_SEND: {
      const params = new URLSearchParams();
      params.append('mobile', String(payload.mobile || '').trim());
      return axios.post(sendOtpUrl(), params, {
        headers: mobileOtpRequestHeaders(),
        timeout,
      });
    }
    case GW.OTP_VERIFY: {
      const params = new URLSearchParams();
      params.append('mobile', String(payload.mobile || '').trim());
      params.append('otp', String(payload.otp || '').trim());
      return axios.post(verifyOtpUrl(), params, {
        headers: mobileOtpRequestHeaders(),
        timeout,
      });
    }
    case GW.VERIFY_PAN:
      return axios.post(loanBackendUrl('verifyPan.php'), payload, {
        headers: jsonHeaders,
        timeout,
      });
    case GW.PAN_BLACKLIST: {
      const pan = encodeURIComponent(String(payload.pancard || payload.pan || '').trim());
      return axios.get(`${taskApiDirectUrl('checkGetCustomerbyPanBlacklist')}?pancard=${pan}`, {
        timeout,
      });
    }
    case GW.PAN_CUSTOMER: {
      const pan = encodeURIComponent(String(payload.pancard || payload.pan || '').trim());
      return axios.get(`${taskApiDirectUrl('checkGetCustomerbyPan')}?pancard=${pan}`, {
        timeout,
      });
    }
    case GW.AADHAAR_SEND:
      return axios.post(loanBackendUrl('sendAadhaarOtp.php'), payload, {
        headers: jsonHeaders,
        timeout,
      });
    case GW.AADHAAR_VERIFY:
      return axios.post(loanBackendUrl('verifyAadhaarOtp.php'), payload, {
        headers: jsonHeaders,
        timeout,
      });
    case GW.SAVE_ENQUIRY: {
      const url = saveEnquiryUrl();
      const resp = await fetch(url, {
        method: 'POST',
        headers: jsonHeaders,
        body: JSON.stringify(payload),
        mode: 'cors',
        keepalive: Boolean(options.keepalive),
      });
      let data = null;
      try {
        data = await resp.json();
      } catch {
        data = null;
      }
      return { data, status: resp.status, ok: resp.ok };
    }
    case GW.SAVE_LEAD:
      return axios.post(saveLendingPageUrl(), payload, { headers: jsonHeaders, timeout });
    default:
      throw new Error('Unknown API action');
  }
};
